import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import {useStoreContext} from '../../../contexts/store'

const Header = ({editStore}) => {
    const intl = useIntl()
    const {store} = useStoreContext()
    const isSelectedStoreView = store && !editStore

    return (
        <Stack gap="5px" paddingRight="24px">
            <Text
                as="h3"
                color="black.300"
                fontFamily="cormorant"
                fontSize="23px"
                fontWeight="400"
                lineHeight="normal"
                letterSpacing="0.115px"
            >
                {isSelectedStoreView
                    ? intl.formatMessage({
                          id: 'select_store_modal.your_pickup_store',
                          defaultMessage: 'Your pickup store'
                      })
                    : intl.formatMessage({
                          id: 'select_store_modal.choose_your_pickup_store',
                          defaultMessage: 'Choose your pickup store'
                      })}
            </Text>
            <Text
                color="black.300"
                fontSize="13px"
                fontWeight="300"
                lineHeight="22px"
                letterSpacing="0.065px"
            >
                {isSelectedStoreView
                    ? intl.formatMessage({
                          id: 'select_store_modal.your_pickup_store_subcopy',
                          defaultMessage: "We'll use this store as your default for store pickup."
                      })
                    : intl.formatMessage({
                          id: 'select_store_modal.choose_your_pickup_store_subcopy',
                          defaultMessage:
                              "Find a store by ZIP code or city and state. We'll use your selection as your default for store pickup."
                      })}
            </Text>
        </Stack>
    )
}

Header.propTypes = {
    editStore: PropTypes.bool
}

export default Header
